<template>
  <main class="l-main p-competing">
    <TitleMain
      icon="competitiveKeyword"
      faq="/sections/360001240035"
      howTo="/sections/4404631671823"
    >
      <span class="title">関連ワード分析</span>
      <span class="description">
        施策を検討しているキーワードに関連するキーワードを調査できます。
      </span>
    </TitleMain>
    <div class="l-container">
      <div class="l-toolBlock">
        <ButtonToProjects />
        <Button
          v-if="$route.name !== 'competitiveKeyword'"
          :to="{
            name: 'competitiveKeyword'
          }"
          variant="light"
          icon="pageback"
          radius
        >
          登録キーワード一覧に戻る
        </Button>
        <Breadcrumb />
      </div>
      <router-view :project="project" />
    </div>
    <portal-target class="c-form-task__wrapper" name="form-add-tasks" />
  </main>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb';
import Button from '@/components/Button';
import ButtonToProjects from '@/components/ButtonToProjects';
import TitleMain from '@/components/TitleMain';

export default {
  props: ['project'],
  components: {
    Breadcrumb,
    Button,
    ButtonToProjects,
    TitleMain
  }
};
</script>
